<template>
  <div
    class="c-question-item"
    :class="{ new: questionData.new, pinned: questionData.pinned }"
    role="article"
  >
    <div class="row with-margins">
      <div class="c-question-item__media">
        <!-- <img src="" alt=""> -->
        <div class="c-question-item__media-img">
          <user-avatar :user="questionData.user" />
        </div>
      </div>
      <div class="c-question-item__content">
        <h2
          class="c-question-item__title"
          @click="$emit('click')"
          @keydown.enter.exact="$emit('click')"
          tabindex="0"
        >
          <icon
            name="attachment"
            v-if="questionData.files"
            class="c-icon c-icon--attach"
          />
          {{ questionData.title }}
        </h2>
        <p
          class="c-question-item__description"
          v-html="truncatedDescription.text"
        ></p>
      </div>
      <div class="c-question-item__view">
        <base-button @click="$emit('click')">View Question</base-button>
      </div>
    </div>

    <div class="c-question-item__meta">
      <meta-row
        :object="questionData"
        :showAvatar="false"
        :showResponseCount="showResponseCount"
        :showAttachment="false"
      ></meta-row>
    </div>
  </div>
</template>

<script>
import trunc from "trunc-html";
import MetaRow from "@/components/MetaRow";
const UserAvatar = () => import("@/components/UserAvatar");

export default {
  name: "question-item",

  components: {
    MetaRow,
    UserAvatar,
  },

  props: ["questionData", "img", "showResponseCount"],

  computed: {
    truncatedDescription() {
      // strip out html tags
      let strippedDesc = this.questionData.description
        ? this.questionData.description.replace(/(<([^>]+)>)/gi, " ")
        : "";
      // replace line breaks with spaces
      return trunc(strippedDesc, 120);
    },
  },
};
</script>

<style lang="scss">
.c-question-item {
  align-items: flex-start;
  cursor: pointer;
  transition: all ease-in-out 0.2s;
  border-bottom: 1px solid $colour-nhs-pale-grey;

  .row {
    display: flex;
    gap: 10px;
  }
  h3 {
    margin-bottom: 10px;
  }

  p {
    margin: 0;
  }

  button {
    transition: border ease-in-out 0.2s;
  }

  &.new {
    background: $colour-nhs-pale-blue;
    border-left: 5px solid $colour-nhs-core-blue;
  }

  padding: 1em;

  &:not(:last-of-type) {
    border-bottom: 1px solid $colour-nhs-pale-grey;
  }

  @media (hover: hover) {
    &:hover {
      box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.11);
      border-bottom-color: transparent;

      h3 {
        color: $colour-nhs-core-blue;
      }

      button {
        border-color: $colour-nhs-core-blue;
      }
    }
  }

  &__media {
    flex: 1;

    @media (min-width: 768px) {
      flex: 10%;
    }
  }

  &__media-img {
    height: 80px;
    width: 80px;
    background: tint($colour-nhs-dark-grey, 80%);
    border-radius: 100%;
    overflow: hidden;
    display: flex;

    img {
      height: 120%;
      @supports (object-fit: cover) {
        object-fit: cover;
        height: auto;
      }
    }
  }

  &__meta {
    margin-bottom: 20px;
  }

  &__content {
    flex: 3;

    @media (min-width: 768px) {
      flex: 5;
      flex: 60%;
    }
  }

  &__title {
    margin-top: 0;
    font-size: 16px;
    color: #202020;
    font-weight: normal;
  }

  &__description {
    color: $colour-nhs-dark-grey;
    font-size: 14px;
    line-height: 1.5;
  }

  &__user {
    font-size: 14px;
    color: $colour-nhs-bright-blue;
  }

  &__view {
    display: none;
    @media screen and (min-width: 768px) {
      display: block;
      align-self: center;
      flex: 20%;
      text-align: right;
    }

    @media screen and (min-width: 1024px) {
      // flex-basis: 20%;
    }
  }
}

.c-icon {
  height: 12px;
  margin-right: 0;
  &--attach {
    path {
      fill: $colour-nhs-dark-grey;
    }
  }
}

.row.with-margins {
  margin-left: 0;
  margin-right: 0;
}
</style>
